/**
 * Modal que muestra el historial de programación de una orden de trabajo
 *
 * @param {Object} props
 * @param {boolean} props.open - Si el modal está visible
 * @param {Array} props.data - Lista de programaciones
 * @param {Object} props.item - Orden de trabajo seleccionada
 * @param {Function} props.onClose - Callback al cerrar
 * @returns {JSX.Element|null}
 */
function HistorialProgramacionModal({ open, data, item, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container modal-container-wide" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Historial de Programación</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          {data.length === 0 ? (
            <p className="text-muted">Sin programaciones registradas</p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Fecha Anterior</th>
                    <th>Nueva Fecha</th>
                    <th>Días</th>
                    <th>Motivo</th>
                    <th>Por</th>
                    <th>Cuándo</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(h => (
                    <tr key={h.id}>
                      <td>{new Date(h.fecha_anterior).toLocaleDateString('es-CL')}</td>
                      <td>{new Date(h.fecha_nueva).toLocaleDateString('es-CL')}</td>
                      <td><span className="badge badge-warning">{h.dias_desfase > 0 ? '+' : ''}{h.dias_desfase}</span></td>
                      <td>
                        <div>{h.motivo_nombre || '-'}</div>
                        {h.motivo && <div className="text-muted">{h.motivo}</div>}
                      </td>
                      <td>{h.created_by}</td>
                      <td>{new Date(h.created_at).toLocaleDateString('es-CL')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default HistorialProgramacionModal;
